import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import api from './api';
import { getAccessToken } from './tokenManager';

class RealtimeService {
  constructor() {
    this.client = null;
    this.connected = false;
    this.subscriptions = new Map();
    this.base = (process.env.REACT_APP_API_URL || 'http://localhost:8080').replace(/\/$/, '');
  }

  async connect() {
    if (this.connected || this.client) return;
    const token = getAccessToken();
    this.client = new Client({
      webSocketFactory: () => new SockJS(`${this.base}/ws`),
      connectHeaders: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      reconnectDelay: 3000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => {
        this.connected = true;
        // resubscribe
        for (const [dest, handler] of this.subscriptions.entries()) {
          this._subscribe(dest, handler);
        }
      },
      onStompError: () => { this.connected = false; },
      onWebSocketClose: () => { this.connected = false; },
    });
    this.client.activate();
  }

  _subscribe(destination, handler) {
    if (!this.client || !this.connected) return;
    const sub = this.client.subscribe(destination, (message) => {
      if (message && message.body) {
        try {
          const data = JSON.parse(message.body);
          handler(data);
        } catch {
          // ignore
        }
      }
    });
    this.subscriptions.set(destination, handler);
    return sub;
  }

  async ensureConnected() {
    if (!this.connected) await this.connect();
  }

  async subscribe(destination, handler) {
    await this.ensureConnected();
    return this._subscribe(destination, handler);
  }
}

const realtime = new RealtimeService();
export default realtime;


